"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.87 7.94 8.24 4.23a.51.51 0 0 0-.48 0L1.13 7.94a.5.5 0 0 0-.182.682.52.52 0 0 0 .182.188l5.29 2.95a.45.45 0 0 0 .25.07.44.44 0 0 0 .24-.07l4.61-2.57 1.09.61a.53.53 0 0 0 .49 0l1.77-1a.52.52 0 0 0 .25-.44.5.5 0 0 0-.25-.42Zm-2 .85-1.09-.61a.46.46 0 0 0-.48 0l-4.63 2.58L2.4 8.37 8 5.24l5.6 3.13-.73.42Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "m22.837 7.665-10.56-5.902a.562.562 0 0 0-.555 0L1.162 7.665a.57.57 0 0 0-.285.495v8.872a.563.563 0 0 0 .285.488L9.6 22.238a.51.51 0 0 0 .27.075.516.516 0 0 0 .277-.075l7.5-4.17 1.853 1.034a.592.592 0 0 0 .547 0l2.82-1.582a.546.546 0 0 0 .285-.488V8.16a.555.555 0 0 0-.315-.495ZM12 2.895l9.412 5.25-1.672.93-1.845-1.02a.547.547 0 0 0-.548 0l-7.5 4.17L2.572 8.16 12 2.895ZM10.432 13.2l6.623-3.697v7.59l-6.623 3.697V13.2Zm7.748-3.697.997.562v7.583l-.997-.555v-7.59Zm-16.178-.39L9.307 13.2v7.59l-7.305-4.087v-7.59Zm18.3 8.535v-7.583l1.695-.952v7.59l-1.695.945Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.45 10.22 16.37 2.35a.75.75 0 0 0-.74 0L1.55 10.22a.76.76 0 0 0-.38.66v11.83a.75.75 0 0 0 .38.65l11.25 6.29a.68.68 0 0 0 .36.1.69.69 0 0 0 .37-.1l10-5.56L26 25.47a.79.79 0 0 0 .73 0l3.76-2.11a.73.73 0 0 0 .38-.65V10.88a.74.74 0 0 0-.42-.66ZM16 3.86l12.55 7-2.23 1.24-2.46-1.36a.73.73 0 0 0-.73 0l-10 5.56-9.7-5.42L16 3.86ZM13.91 17.6l8.83-4.93v10.12l-8.83 4.93V17.6Zm10.33-4.93 1.33.75v10.11l-1.33-.74V12.67Zm-21.57-.52 9.74 5.45v10.12l-9.74-5.45V12.15Zm24.4 11.38V13.42l2.26-1.27v10.12l-2.26 1.26Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.735 15.435 24.458 3.54a.945.945 0 0 0-.915 0L2.28 15.435a.945.945 0 0 0-.48.825v17.857a.945.945 0 0 0 .48.826l16.995 9.495a.93.93 0 0 0 .915 0L35.28 36l3.833 2.138a.944.944 0 0 0 .915 0l5.677-3.173a.946.946 0 0 0 .48-.825V16.26a.945.945 0 0 0-.45-.825ZM24.03 5.437 43.388 16.26l-3.75 2.1-3.833-2.145a.945.945 0 0 0-.915 0l-15.172 8.468L4.643 16.26 24.03 5.437ZM20.655 26.31l13.718-7.672v15.75l-13.718 7.657V26.31Zm15.593-7.672 2.415 1.342v15.75l-2.415-1.35V18.637Zm-32.588-.75 15.12 8.422v15.75L3.66 33.592V17.889Zm36.87 17.834v-15.75l3.803-2.122V33.6l-3.803 2.122Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M60.98 20.58 32.61 4.72a1.26 1.26 0 0 0-1.22 0L3.04 20.58a1.26 1.26 0 0 0-.64 1.1v23.81a1.26 1.26 0 0 0 .64 1.1L25.7 59.25a1.24 1.24 0 0 0 1.22 0L47.04 48l5.11 2.85a1.26 1.26 0 0 0 1.22 0l7.57-4.23a1.26 1.26 0 0 0 .64-1.1V21.68a1.26 1.26 0 0 0-.6-1.1ZM32.04 7.25l25.81 14.43-5 2.8-5.11-2.86a1.26 1.26 0 0 0-1.22 0L26.29 32.91 6.19 21.68 32.04 7.25Zm-4.5 27.83 18.29-10.23v21L27.54 56.06V35.08Zm20.79-10.23 3.22 1.79v21l-3.22-1.8V24.85Zm-43.45-1 20.16 11.23v21L4.88 44.79V23.85Zm49.16 23.78v-21l5.07-2.83v21l-5.07 2.83Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCeilingFlat = function IconCeilingFlat(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Ceiling Flat' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CeilingFlat"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCeilingFlat.sizes = [16, 24, 32, 48, 64];
IconCeilingFlat.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCeilingFlat;
exports.default = _default;